import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    lastUpdated: null,
  },
  reducers: {
    menuUpdated(state) {
      state.lastUpdated = Date.now();
    },
  },
});

export const { menuUpdated } = menuSlice.actions;
export default menuSlice.reducer;